/**
 * Gift Modal Component
 * Allows sending virtual gifts to other players
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Gift } from 'lucide-react';

const GIFT_ITEMS = [
  { id: 'drink', name: 'Drink', emoji: '🍹', cost: 10 },
  { id: 'flowers', name: 'Flowers', emoji: '💐', cost: 25 },
  { id: 'confetti', name: 'Confetti', emoji: '🎊', cost: 50 },
  { id: 'spotlight', name: 'Spotlight', emoji: '🔦', cost: 100 },
  { id: 'crown', name: 'Crown', emoji: '👑', cost: 200 },
];

const GiftModal = ({
  isOpen,
  onClose,
  targetPlayer,
  vibecoins,
  onSendGift
}) => {
  if (!isOpen || !targetPlayer) return null;

  return (
    <div 
      className="fixed inset-0 z-[9990] flex items-center justify-center bg-black/80 p-4"
      onClick={onClose}
      data-testid="gift-modal-overlay"
    >
      <Card 
        className="w-full max-w-sm bg-gray-900 border-pink-500/30" 
        onClick={e => e.stopPropagation()}
        data-testid="gift-modal"
      >
        <CardHeader className="text-center pb-2">
          <CardTitle className="text-white flex items-center justify-center gap-2">
            <Gift className="w-5 h-5 text-pink-400" />
            Send Gift to {targetPlayer.name}
          </CardTitle>
          <p className="text-white/60 text-sm">Your balance: 💰 {vibecoins} VibeCoins</p>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="grid grid-cols-1 gap-2">
            {GIFT_ITEMS.map(gift => (
              <button
                key={gift.id}
                onClick={() => onSendGift(gift.id)}
                disabled={vibecoins < gift.cost}
                className={`flex items-center justify-between p-3 rounded-lg transition-all ${
                  vibecoins >= gift.cost 
                    ? 'bg-black/30 hover:bg-pink-500/20 border border-white/10 hover:border-pink-500/40' 
                    : 'bg-black/10 opacity-50 cursor-not-allowed border border-white/5'
                }`}
                data-testid={`gift-option-${gift.id}`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-2xl">{gift.emoji}</span>
                  <span className="text-white font-medium">{gift.name}</span>
                </div>
                <span className={`font-bold ${vibecoins >= gift.cost ? 'text-yellow-400' : 'text-red-400'}`}>
                  💰 {gift.cost}
                </span>
              </button>
            ))}
          </div>
          <Button onClick={onClose} variant="ghost" className="w-full text-white/60" data-testid="cancel-gift">
            Cancel
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export { GIFT_ITEMS };
export default GiftModal;
